import styled, { css } from "styled-components";

const Card = styled.div<{ onClick?: () => void }>`
  padding: 16px 20px;
  background: white;
  color: #14161a;
  border-radius: 12px;
  box-shadow: rgba(9, 14, 21, 0.06) 0px 4px 28px 0px, rgba(9, 14, 21, 0.06) 0px 1px 4px 0px;
  border: 1px solid #f5f5f5;
  font-family: system-ui, "Open Sans", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji";

  ${props => props.onClick && css`
    cursor: pointer;
  `}
`

export default Card